import { gql } from '@apollo/client';

export const ALL_AUDIENCE_SIZES = gql`
  query AllAudienceSizes {
    audienceSizes: getAudienceSizes {
      id
      name
    }
  }
`;
